<template>
  <v-flex>
    <v-col style="width: 100%" wrap>
      <v-list
        class="pt-0"
        dense
      >
        <v-list-item
          v-for="(dgd,index) in driverGroup.driverGroupConstrainToUsers"
          :key="dgd.id"
        > 
          <v-flex md3>
          <v-text>{{ dgd.user.id }}</v-text>
        </v-flex>
        <v-flex md3>
          <v-text>{{ dgd.user.name }}</v-text>
        </v-flex>
        <v-flex md3>
          <v-btn @click="removeDriver(dgd.user.id, index)" small>Remove</v-btn>
        </v-flex>
        </v-list-item>
      </v-list>
      <v-flex mt-5>
        <SelectableDriverUserInput
          :driver="'egg'"
          :user="null"
          @update="handleUpdate"
          label="Enter id or name"
        />
      <v-flex pt-3></v-flex><v-btn @click="addDriver" small>Add User</v-btn></v-flex>
    </v-col>
  </v-flex>
</template>

<script>

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;


import SelectableDriverUserInput from "@/components/widget/input/SelectableDriverUserDropdownInputForNoMatch.vue";


export default {
  name: "driver_group_form",
  components: {
    SelectableDriverUserInput
  },
  props: {
    driverGroup: Object
  },
  data: function() {
    return {
      addDriverId: null,
    };
  },
  mounted: function() {
  },
  methods: {
    addDriver() {

      let url = `${this.$store.state.apiUrl}/driver_group/${this.driverGroup.id}/addUserToGroup?userId=${this.addDriverId}`;

      let self = this;

      axios({
        url: url,
        method: "post",
        data: {},
      }).then(function(response) {
        console.log(response.data.errors);

        self.driverGroup.driverGroupConstrainToUsers.push(response.data)

      }).catch(function(error) {
      
      });
    },
    removeDriver(userId, index) {

      let url = `${this.$store.state.apiUrl}/driver_group/removeUserFromGroup?userId=${userId}`;

      let self = this;

      axios({
        url: url,
        method: "post",
        data: {},
        headers: {
          'Content-Type': 'text/plain'
        }
      }).then(function(response) {
        console.log(response.data.errors)

        self.driverGroup.driverGroupConstrainToUsers.splice(index,1);        

      }).catch(function(error) {
      
      });
    },
    handleUpdate(id) {
      console.log("Driver selected " + id);
      this.addDriverId = id;
    },
    errorForField: function(field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function(field) {
      try {
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function() {
      this.$refs.loyaltyTierForm.validate();
    }
  },
  watch: {
    valid: function() {
      this.$emit("validityChange", this.valid);
    }
  }
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>